import { designToken, quickProperty } from '../component-tokens';
import { baseSmallIcon, baseMediumIcon, baseLargeIcon } from './button';
import { buttonBase, tertiaryElementFocus, tertiaryElement } from './common';
export const linkTokens = {
    name: 'link',
    reactImports: 'Link',
    attributes: Object.assign(Object.assign(Object.assign(Object.assign({}, buttonBase), tertiaryElement), baseSmallIcon), { '--goto-icon-color': designToken('icon-color-brand-default'), padding: quickProperty('0px 2px'), margin: quickProperty('0px -2px'), 'text-decoration': quickProperty('var(--goto-link-text-decoration, none)'), color: quickProperty(`var(--goto-type-color-brand-default, var(--goto-${tertiaryElement.color.name}))`) }),
    states: [
        {
            name: 'focus',
            attributes: Object.assign(Object.assign({}, tertiaryElementFocus), { 'box-shadow': designToken('interactive-color-secondary-pressed') }),
        },
        {
            name: 'hover',
            attributes: {
                'text-decoration': quickProperty('underline'),
            },
        },
        {
            name: 'disabled',
            attributes: {
                color: designToken('type-color-disabled'),
            },
        },
    ],
    variants: [
        {
            name: 'body-small',
            attributes: {
                font: designToken('body-small'),
            },
        },
        {
            name: 'body-medium',
            attributes: Object.assign(Object.assign({}, baseMediumIcon), { font: designToken('body-medium') }),
        },
        {
            name: 'body-large',
            attributes: Object.assign(Object.assign({}, baseLargeIcon), { font: designToken('body-large') }),
        },
        {
            name: 'caption-medium',
            attributes: {
                font: designToken('caption-medium'),
            },
        },
        {
            name: 'caption-medium-strong',
            attributes: {
                font: designToken('caption-medium-strong'),
            },
        },
        {
            name: 'caption-small',
            attributes: {
                font: designToken('caption-small'),
            },
        },
        {
            name: 'caption-small-strong',
            attributes: {
                font: designToken('caption-small-strong'),
            },
        },
    ],
};
